import HTTP from '@/common/HTTP'

import { mutationTypes, actionTypes } from './AuditEditTypes';
import { actionTypes as globalActionTypes } from './GlobalTypes'

function initialState() {
  return {
    audit: {
      name: '',
      description: '',
    },
  }
}

const mutations = {
  [mutationTypes.SET_AUDIT](state, item) {
    state.audit = item
  },

  [mutationTypes.SET_PREPARABLE_DEFICIENCIES](state, { setId, deficiencies }) {
    state.preparableDeficiencies[setId] = deficiencies;
  }
}

const actions = {
  async [actionTypes.FETCH_AUDIT]({ commit }, id) {
    const audit = (await HTTP.get(`/audits/${id}`)).data;
    audit.auditObject = audit.auditObject.id
    audit.surveyVersion = audit.surveyVersion.id
    delete audit.survey;

    commit(mutationTypes.SET_AUDIT, audit)
  },

  async [actionTypes.UPDATE_AUDIT]({ state, commit, dispatch }, audit) {
    dispatch(globalActionTypes.SHOW_SNACKBAR, {
      message: 'Audit wurde gespeichert.',
      color: 'success'
    }, { root: true })
    return HTTP.patch(`/audits/${audit.id}`, audit)
  },
}

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/AuditEdit.js